export default __webpack_public_path__ + "static/media/bg9.32833923.jpg";